import React from "react";

const TextArea = ({
  id = "",
  name = "",
  value = "",
  placeholder = "",
  disabled = false,
  error = "",
  onChange = () => {},
}) => {
  return (
    <div>
      <textarea
        className="p-4 border-[1px] border-[#dddddd] focus:border-[#aaaaaa] ring-0 focus:ring-0 active:ring-0 placeholder-[#BDBDBD] rounded-[0.625rem] w-full"
        placeholder={placeholder}
        id={`${id}`}
        name={`${name}`}
        value={`${value}`}
        disabled={disabled}
        onChange={onChange}
        rows={`7`}
      />
      <div className="h-2">
        <label
          htmlFor={id}
          className="font-normal text-[0.75rem]  text-red-500 bg-white  my-0 py-0 font"
        >
          {error}
        </label>
      </div>
    </div>
  );
};

export default TextArea;
